import { createStyle } from '@gluestack-style/react';

export const KeyboardAvoidingView = createStyle({});
